/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import { gql } from 'urql';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';

import { ValidationErrorFieldsFragmentDoc } from '../../../graphql/fragments/ValidationErrorFields.generated';
import { DeliveryOrderDetailFragmentDoc } from '../../../hooks/useCart/GraphQL/Cart.generated';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type DeliveryPreferenceType = 'CURBSIDE' | 'DOOR' | 'LEAVE_AT_DOOR';

export type OrderSource =
  | 'DOORDASH_MARKETPLACE'
  | 'EZCATER_B2B_MARKETPLACE'
  | 'EZCATER_MARKETPLACE'
  | 'EZ_ORDERING'
  | 'FOODA_MARKETPLACE'
  | 'GENERIC_MARKETPLACE'
  | 'GRUBHUB_MARKETPLACE'
  | 'KIOSK'
  | 'MEALPAL_MARKETPLACE'
  | 'NATIVE'
  | 'SHAREBITE_MARKETPLACE'
  | 'UBER_EATS_MARKETPLACE';

export type OrderType =
  | 'CATERING'
  | 'CATERING_DELIVERY'
  | 'CATERING_PICKUP'
  | 'DELIVERY'
  | 'IN_STORE'
  | 'PICKUP';

export type OrdersInput = {
  readonly page: number;
  readonly take: number;
};

export type OrdersQueryVariables = Exact<{
  input: Types.OrdersInput;
}>;

export type OrdersQuery = {
  readonly orders:
    | {
        readonly __typename: 'OrdersResponseSuccess';
        readonly orders: ReadonlyArray<{
          readonly __typename: 'Order';
          readonly id: string;
          readonly description: string;
          readonly orderType: Types.OrderType;
          readonly orderSource: Types.OrderSource | null;
          readonly total: number | null;
          readonly asset: { readonly url: string };
          readonly lineItems: ReadonlyArray<{
            readonly __typename: 'LineItem';
            readonly id: string;
            readonly quantity: number;
            readonly customName: string | null;
            readonly isCustom: boolean;
            readonly product: {
              readonly __typename: 'Product';
              readonly id: string;
              readonly name: string;
              readonly isCustom: boolean;
              readonly categoryName: string;
            };
          }>;
          readonly restaurant: {
            readonly __typename: 'Restaurant';
            readonly id: string;
            readonly name: string;
            readonly city: string;
            readonly state: string;
            readonly address: string;
            readonly zipCode: string;
            readonly isOutpost: boolean;
            readonly slug: string;
          };
          readonly deliveryOrderDetail: {
            readonly __typename: 'DeliveryOrderDetail';
            readonly id: string;
            readonly tip: number;
            readonly deliveryFee: number;
            readonly vendor: string;
            readonly orderId: string;
            readonly vendorRestaurantId: string;
            readonly estimatedDeliveryTime: string | null;
            readonly address: {
              readonly __typename: 'Address';
              readonly id: string;
              readonly street: string;
              readonly secondaryStreet: string | null;
              readonly city: string;
              readonly state: string;
              readonly country: string;
              readonly zipCode: string;
              readonly deliveryPreference: Types.DeliveryPreferenceType;
              readonly googlePlaceId: string;
              readonly latitude: number;
              readonly longitude: number;
              readonly name: string | null;
              readonly notes: string | null;
            } | null;
          } | null;
        }>;
      }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{ readonly field: string; readonly message: string }>;
      };
};

export const OrdersDocument = gql`
  query orders($input: OrdersInput!) {
    orders(input: $input) {
      __typename
      ... on OrdersResponseSuccess {
        orders {
          id
          __typename
          description
          orderType
          orderSource
          total
          asset {
            url
          }
          lineItems {
            id
            __typename
            quantity
            customName
            isCustom
            product {
              id
              __typename
              name
              isCustom
              categoryName
            }
          }
          restaurant {
            id
            __typename
            name
            city
            state
            address
            zipCode
            isOutpost
            slug
          }
          deliveryOrderDetail {
            ...DeliveryOrderDetail
          }
        }
      }
      ...ValidationErrorFields
    }
  }
  ${DeliveryOrderDetailFragmentDoc}
  ${ValidationErrorFieldsFragmentDoc}
`;

export function useOrdersQuery(options: Omit<Urql.UseQueryArgs<OrdersQueryVariables>, 'query'>) {
  return Urql.useQuery<OrdersQuery, OrdersQueryVariables>({ query: OrdersDocument, ...options });
}
